import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import OrganisationAutocomplete from 'components/OrganisationPicker/OrganisationAutocomplete';
import { OrganisationResponse } from 'api';
import { styled } from '@mui/material';
import { Dialog } from '@insights-ltd/design-library/components';

const StyledOrganisationAutocomplete = styled(OrganisationAutocomplete)({
  width: '100%',
  '& > div > div': {
    marginRight: '0',
  },
});

const Divider = styled('div')(({ theme }) => ({
  width: '140.5px',
  border: `1px solid ${theme.palette.grey[500]}`,
  height: '0',
}));

const StyledDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  margin: '18px 0 10px',
});

const Span = styled('span')(({ theme }) => ({
  fontWeight: '600',
  margin: '0 0.75rem',
  color: theme.palette.text.secondary,
}));

type ChangeOrgDialogProps = {
  open: boolean;
  onClose: () => void;
  selectedOrg?: OrganisationResponse;
  handleOrganisationChange: (value: OrganisationResponse | null) => void;
  hasAllOrgsOption: boolean;
};

const ChangeOrgDialog = ({
  open,
  onClose,
  selectedOrg,
  handleOrganisationChange,
  hasAllOrgsOption,
}: ChangeOrgDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      title={t('ui.event-management.learners.organisation.change-org')}
      open={open}
      onClose={onClose}
      aria-labelledby="confirmation-dialog-title"
      aria-describedby="confirmation-dialog-description"
      content={
        <>
          {hasAllOrgsOption && (
            <>
              <Button
                fullWidth
                onClick={() => {
                  onClose();
                  handleOrganisationChange(null);
                }}
                color="primary"
                variant="outlined"
                sx={(theme) => ({
                  border: `2px solid ${theme.palette.blue.main} !important`,
                })}
              >
                {t(
                  'ui.event-management.learners.organisation.change-org.view-all',
                )}
              </Button>
              <StyledDiv>
                <Divider />
                <Span>
                  {t('ui.event-management.learners.organisation.change-org.or')}
                </Span>
                <Divider />
              </StyledDiv>
            </>
          )}
          <StyledOrganisationAutocomplete
            onSelect={(organisation) => {
              onClose();
              handleOrganisationChange(organisation);
            }}
            currentOrg={selectedOrg}
            disableClearable
          />
        </>
      }
    />
  );
};

export default ChangeOrgDialog;
